module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/22807fb96996621e3222c326efb46398.png";